import { Carousel } from "../carousel/Carousel";
import { ProductCard } from "../productCard/ProductCard";
import { Link } from "react-router-dom";
import Hero from "./Hero";
import sp1 from "../../assets/safety-products/sp-1.png";
import dp1 from "../../assets/disposable-products/dp-1.png";
import sup1 from "../../assets/surgical-products/sup-1.png";
import fp1 from "../../assets/furniture-products/FP-1.png";
import sp2 from "../../assets/safety-products/sp-2.png";
import dp2 from "../../assets/disposable-products/dp-2.png";
import sup2 from "../../assets/surgical-products/sup-2.png";
import fp2 from "../../assets/furniture-products/FP-2.png";

export default function Home() {
  return (
    <main>
      <Hero />

      <section className="container">
        <Carousel>
          <Link to="/safety">
            <ProductCard title=" Protective clothing" img={sp1} />
          </Link>
          <Link to="/disposable">
            <ProductCard title="Face Mask" img={dp1} />
          </Link>
          <Link to="/surgical">
            <ProductCard title="Oxygen Mask" img={sup1} />
          </Link>
          <Link to="/furniture">
            <ProductCard title="ICU Bed" img={fp1} />
          </Link>
          <Link to="/safety">
            <ProductCard title="Safety Shoes" img={sp2} />
          </Link>
          <Link to="/disposable">
            <ProductCard title="Disposable Lab Coat" img={dp2} />
          </Link>
          <Link to="/surgical">
            <ProductCard title="Urine Collection Bag" img={sup2} />
          </Link>
          <Link to="/furniture">
            <ProductCard title="Examination Couch" img={fp2} />
          </Link>
        </Carousel>
      </section>

      <section className="summary">
        <div className="container grid-3">
          <div className="card">
            <h3>Safety Products</h3>
            <p>
              Industrial and medical PPE: masks, gloves, gowns, shields, and
              more.
            </p>
            <Link to="/safety">Browse Safety</Link>
          </div>
          <div className="card">
            <h3>Disposable & Surgical</h3>
            <p>
              Single‑use consumables and sterile surgical supplies with
              traceability.
            </p>
            <Link to="/disposable">Explore Disposables</Link>
          </div>
          <div className="card">
            <h3>Furniture & Devices</h3>
            <p>
              Beds, trolleys, stools, and essential clinical equipment with
              service support.
            </p>
            <Link to="/furniture">See Furniture</Link>
          </div>
        </div>
      </section>

      <style>{`
        .hero{background:linear-gradient(180deg,#ffffff,#f2f9fe)}
        .hero-grid{display:grid;grid-template-columns:1.2fr .8fr;gap:24px;align-items:center;padding:32px 0}
        .hero-copy h1{margin:.2em 0;font-size:32px;line-height:40px}
        .hero-copy p{color:#334155;margin:8px 0 16px}
        .cta{display:inline-flex;align-items:center;gap:8px;height:44px;padding:0 16px;border-radius:10px;background:var(--brand);color:#fff;font-weight:700}
        .badges{display:flex;flex-wrap:wrap;gap:8px;margin-top:16px}
        .badges span{background:#e6f6fd;color:#035b7c;padding:6px 10px;border-radius:999px;font-size:14px}
        .hero-img{width:100%;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,.08);height:22em}
        .summary{padding:24px 0}
        .grid-3{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px}
        .card{background:#fff;border:1px solid var(--border);border-radius:12px;padding:16px}
        .link{color:var(--brand);font-weight:600}
        @media(max-width:960px){.hero-grid{grid-template-columns:1fr}}
      `}</style>
    </main>
  );
}
